import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-39d8e111"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "group-title"
}, "下载内容", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "账号信息"), /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "基础信息包括您的摩点ID、昵称、账号绑定手机号等")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "设备信息"), /*#__PURE__*/_createElementVNode("div", {
  class: "des"
}, "您当前在线的设备信息")], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "group-title"
}, "下载设置", -1));
const _hoisted_6 = {
  class: "email-custom-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "邮箱地址", -1));
const _hoisted_8 = {
  class: "input-info"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "foot-des"
}, "我们将在5个工作日内发送至您的邮箱", -1));
const _hoisted_10 = {
  class: "action-info"
};
const _hoisted_11 = {
  class: "btn-info"
};
const _hoisted_12 = ["onClick"];
import { sendDownloadUserInfoRequest } from "@/api";
import { computed, onMounted, reactive } from "vue";
import { GoBack, mdAlert, mdToast } from "../../utils/tools";
export default {
  setup(__props) {
    const state = reactive({
      email: '',
      device: '',
      deviceID: ''
    });
    onMounted(() => {
      document.title = '个人信息下载';

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "onGetDeviceInfo",
        functionParams: {},
        callBack: e => {
          state.device = e.data.device;
          state.deviceID = e.data.deviceId;
        }
      });
    });
    const emailEnabled = computed(() => {
      if (state.email == '' || state.email.length == 0) {
        return false;
      }
      return true;
    });
    function handleSubmitAction() {
      if (emailEnabled.value == false) {
        return;
      }
      mdAlert({
        title: '确认邮箱地址',
        content: `文件将发送至${state.email}，涉及到个人隐私信息，请确认邮箱是否正确，提交后无法更改`,
        actions: ['取消', '确认'],
        _callback: () => {
          //发起请求
          sendSubmitRequest();
        }
      });
    }
    async function sendSubmitRequest() {
      const {
        status,
        message
      } = await sendDownloadUserInfoRequest({
        'email': state.email,
        'device': state.device,
        'anonymousid': state.deviceID
      });
      if (status == 0) {
        submitSuccess();
      } else {
        mdToast(message);
      }
    }
    function submitSuccess() {
      mdAlert({
        title: '提交成功',
        content: `我们将在5个工作日内将文件发送到您的邮箱：${state.email}`,
        actions: ['确认'],
        _callback: () => {
          //关闭当前页面
          GoBack();
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_van_divider = _resolveComponent("van-divider");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_cell_group, {
        inset: "",
        class: "account-group"
      }, {
        title: _withCtx(() => [_hoisted_2]),
        default: _withCtx(() => [_hoisted_3, _createVNode(_component_van_divider, {
          class: "line",
          style: {
            color: '#F2F2F2',
            height: '2px'
          }
        }), _hoisted_4]),
        _: 1
      }), _createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        title: _withCtx(() => [_hoisted_5]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_field, {
          class: "input",
          modelValue: _unref(state).email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(state).email = $event),
          border: false,
          placeholder: "输入你的邮箱地址",
          "input-align": "right",
          "label-width": 0,
          type: "email"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_image, {
          class: "arrow",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/protocal_export_arrow.png', 28),
          "lazy-load": ""
        }, null, 8, ["src"])])])]),
        _: 1
      }), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
        class: _normalizeClass(["action-btn", {
          gray: _unref(emailEnabled) == false
        }]),
        onClick: _withModifiers(handleSubmitAction, ["stop"])
      }, "提交", 10, _hoisted_12)])])], 64);
    };
  }
};